function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
//@ts-ignore
import { getSingleElement } from "@utils/DOMUtils";
//@ts-ignore
import { getPreviousNextRealEstate, getPreviousNextRealEstateDirect } from "@services/realEstateAPI";
var pagination;
var realEstate = window["_serializedRealEstateBean"] ? JSON.parse(window["_serializedRealEstateBean"]) : null;
export function create(count, pageSize, currentPage, page, searchBean, backURL) {
  var pagination = {
    count: count,
    pageSize: pageSize,
    backURL: backURL,
    pages: _defineProperty({}, currentPage, page),
    fromListing: true,
    direct: false,
    searchBean: searchBean
  };
  localStorage.setItem("pagination", JSON.stringify(pagination));
}
export function initPagination() {
  var _this = this;
  var fromMap;
  //Matteo C.: fix per quando si arriva dall'area pro, Chrome non permette di usare l'opener se si arriva da un dominio diverso
  try {
    fromMap = window.opener && window.opener.location.hash === "#map";
  } catch (_a) {
    fromMap = false;
  }
  var promises = [
  // Andrea M: da listato / mappa, ho già l'oggetto pagination
  function () {
    return new Promise(function (resolve) {
      var obj = localStorage.getItem("pagination");
      if (!obj) resolve(null);else {
        var _pagination = JSON.parse(obj);
        resolve(_pagination);
      }
    });
  },
  // Andrea M: accesso diretto, devo chiamare la pagination direct
  function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var searchBean, _pagination2;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (realEstate) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", null);
          case 2:
            searchBean = buildSearchBeanFromRealEstate(realEstate);
            _context.prev = 3;
            _context.next = 6;
            return getPreviousNextRealEstateDirect(searchBean);
          case 6:
            _pagination2 = _context.sent;
            if (_pagination2) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", null);
          case 9:
            _pagination2.direct = true;
            return _context.abrupt("return", _pagination2);
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](3);
            console.error(_context.t0);
            return _context.abrupt("return", null);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 13]]);
    }));
  }];
  return new Promise(function (resolve, reject) {
    // Andrea M: eseguo le promise in ordine per ottenere l'oggetto pagination
    //Short-circuit on first pagination found
    promises.reduce(function (acc, fn) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return acc;
            case 2:
              data = _context2.sent;
              return _context2.abrupt("return", data ? data : fn());
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    }, Promise.resolve(null)).then(function (pagination) {
      var _a, _b;
      if (!pagination) {
        reject("No pagination object found");
        return;
      }
      pagination.fromMap = fromMap;
      // Andrea M: controllo se l'immobile corrente è già nelle pagine o è in testa, se non c'è lo metto in testa
      if (!pagination.head && (pagination === null || pagination === void 0 ? void 0 : pagination.pages)) {
        var found = (_a = Object.keys(pagination.pages)) === null || _a === void 0 ? void 0 : _a.some(function (key) {
          var page = pagination.pages[parseInt(key)];
          return page === null || page === void 0 ? void 0 : page.some(function (re) {
            return re.id === window["_referenceId"];
          });
        });
        if (!found) {
          pagination.head = window["_referenceId"] || 0;
          (_b = pagination.pages[1]) === null || _b === void 0 ? void 0 : _b.unshift({
            id: window["_referenceId"],
            url: window["_canonicalURL"]
          });
        }
      }
      localStorage.setItem("pagination", JSON.stringify(pagination));
      resolve(pagination);
    });
  });
}
export var getPagination = function getPagination() {
  return pagination;
};
export function writePagination(pagination) {
  localStorage.setItem("pagination", JSON.stringify(pagination));
}
export function init() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var data, pagesNumber, flattenedPages, k, v, _iterator, _step, insertion, index, curInsertion;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return initPagination();
        case 3:
          data = _context3.sent;
          if (data) {
            _context3.next = 7;
            break;
          }
          hidePagination();
          return _context3.abrupt("return");
        case 7:
          pagination = data;
          pagesNumber = Object.keys(pagination.pages); //In this case, we selected the last real estate insertion of a list of insertions with size equal to 25
          //If we are in the last page, it's pointless to get another page since there won't be any
          if (!(pagesNumber.length < 2 && pagination.idx === pagination.pageSize - 1 && parseInt(pagesNumber[0] + 1) * pagination.pageSize < pagination.count)) {
            _context3.next = 14;
            break;
          }
          _context3.next = 12;
          return getPage(parseInt(pagesNumber[0]) + 1, pagination.searchBean);
        case 12:
          _context3.next = 17;
          break;
        case 14:
          if (!(pagesNumber.length < 2 && !pagination.idx && parseInt(pagesNumber[0]) > 1)) {
            _context3.next = 17;
            break;
          }
          _context3.next = 17;
          return getPage(parseInt(pagesNumber[0]) - 1, pagination.searchBean);
        case 17:
          flattenedPages = []; //Flattening the pages
          for (k in pagination.pages) {
            v = pagination.pages[k];
            _iterator = _createForOfIteratorHelper(v);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                insertion = _step.value;
                flattenedPages.push(Object.assign(Object.assign({}, insertion), {
                  pageNumber: parseInt(k)
                }));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
          //Removing duplicates
          flattenedPages = flattenedPages.reduce(function (acc, cur, idx) {
            var _idx = acc.length ? ((acc[acc.length - 1].idx || 0) + 1) % pagination.pageSize : idx;
            return acc.find(function (i) {
              return i.id === cur.id;
            }) ? acc : [].concat(_toConsumableArray(acc), [Object.assign(Object.assign({}, cur), {
              idx: _idx
            })]);
          }, []);
          index = flattenedPages.findIndex(function (i) {
            return i.id === window["_referenceId"];
          });
          if (index >= 0) {
            curInsertion = flattenedPages[index];
            draw(curInsertion.idx || 0, curInsertion.pageNumber, pagination.count, getPrevURL(index, flattenedPages), getNextURL(index, flattenedPages), pagination.backURL);
          } else hidePagination();
          _context3.next = 29;
          break;
        case 24:
          _context3.prev = 24;
          _context3.t0 = _context3["catch"](0);
          console.error("Cannot create pagination object");
          console.log(_context3.t0);
          hidePagination();
        case 29:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 24]]);
  }));
}
function getPrevURL(index, insertionList) {
  return index > 0 ? insertionList[index - 1].url : "";
}
function getNextURL(index, insertionList) {
  return index <= insertionList.length - 2 ? insertionList[index + 1].url : "";
}
function hidePagination() {
  getSingleElement("#pagination").remove();
}
function draw(index, pageNumber, count, prevURL, nextURL, backURL) {
  var position;
  // Andrea M: se non è paginazione diretta la posizione è semplicemente il numero di pagina - 1 per
  // 20 + l'indice + 1 (perchè l'indice è 0-indexed).
  // Se invece è paginazione diretta devo sommare la lunghezza delle pagine precedenti a quella a
  // in cui sono, perchè la prima pagina è di 21 elementi (l'elemento direct è in testa) e può essere
  // presente una pagina di 19 elementi (la pagina che realmente contiene l'elemento direct)
  if (!pagination.head) position = (pageNumber - 1) * pagination.pageSize + index + 1;else position = Object.keys(pagination.pages).filter(function (key) {
    return parseInt(key) < pageNumber;
  }).reduce(function (acc, page) {
    return acc + pagination.pages[Number(page)].length;
  }, 0) + index + 1;
  var positionEl = getSingleElement("#position");
  var prevReEl = getSingleElement("#prevRE");
  var nextReEl = getSingleElement("#nextRE");
  // convert in string only for the showing data
  var positionThousand = position.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  var countThousand = count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  positionEl.innerHTML = "<span class=\"font-weight-semibold\">".concat(positionThousand, "</span>/").concat(countThousand);
  if (prevURL) prevReEl.setAttribute("href", String(prevURL));else prevReEl.remove();
  //TODO: da fixare lato back in quanto non dovrebbe essere possibile avere altri immobili se si è già all'ultimo del listato
  if (nextURL && position < count) nextReEl.setAttribute("href", String(nextURL));else nextReEl.remove();
}
function getPage(pageNumber, searchBean) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var page;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return getPreviousNextRealEstate(searchBean, pageNumber);
        case 2:
          page = _context4.sent;
          if (page) {
            _context4.next = 5;
            break;
          }
          return _context4.abrupt("return");
        case 5:
          // Andrea M: se ho un immobile in testa e lo trovo nella pagina successiva lo tolgo dalla pagina
          if (pagination.head) page = page.filter(function (re) {
            return re.id !== pagination.head;
          });
          //We are not just insering the new page to the pages object... but we are also inserting in an ASC order the keys!
          pagination.pages[pageNumber] = page;
          localStorage.setItem("pagination", JSON.stringify(pagination));
        case 8:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
}
export function find(pagination, id) {
  return Object.keys(pagination.pages).some(function (key) {
    // @ts-ignore
    return pagination.pages[key].some(function (item) {
      return item.id === id;
    });
  });
}
function buildSearchBeanFromRealEstate(realEstate) {
  if (!realEstate) return {};
  return {
    id: realEstate.id,
    sale: realEstate.sale,
    rent: realEstate.rent,
    auctionType: realEstate.auction ? 1 : 0,
    macroTypologyId: realEstate.macroTypologyID,
    cityId: realEstate.cityID,
    typologyId: realEstate.typologyType,
    localityIdList: realEstate.localityID ? [realEstate.localityID] : undefined,
    zoneIdList: realEstate.zoneID ? [realEstate.zoneID] : undefined
  };
}